import http from './index'
import qs from "qs"

export const login = param => { return http.post("lab-datacenter/dataPlatformManagerLab/platformLogin", param).then(res => res.data.data) };

//getLoginByToken
export const userMsg = param => { return http.post("lab-datacenter/dataPlatformManagerLab/getLoginByToken", param).then(res => res.data.data) };


//字典项
export const dictDataList = param =>{return http.post('common/common/selectDictDataList',param).then(res=>res.data.data)};
//所有省份
export const provinceList = param =>{return http.post('common/common/selectProvinceList',param).then(res=>res.data.data)};
//根据省份Id、市Id 获取下级列表
export const nextList = param =>{return http.post('common/common/selectNextList',qs.stringify(param)).then(res=>res.data.data)};


//医院下拉列表
export const hospital = param => { return http.post("lab-datacenter/dataPlatformManagerLab/selectHospitalList", param).then(res => res.data.data) };
// 实验室下拉列表
export const lab = param => { return http.post("lab-datacenter/dataPlatformManagerHospital/selectLabList", param).then(res => res.data.data) };


// WEBPACK FOOTER //
// ./src/http/commom.js